import { render, staticRenderFns } from "./Blank.vue?vue&type=template&id=28bfd51a&"
var script = {}
import style0 from "./Blank.vue?vue&type=style&index=0&id=28bfd51a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports